export const urls = {
  user: {
    me: '/user/me',
    create: '/user/create',
    confirmEmail: '/user/confirmEmail',
    setPassword: '/user/setPassword',
    resetPassword: '/user/resetPassword',
    resetPasswordCheckToken: '/user/resetPasswordCheckToken',
    resetPasswordSetPassword: '/user/resetPasswordSetPassword',
    upgradeAccount: '/user/upgradeAccount'
  },
  auth: {
    login: '/auth/login',
    googleAuthUrl: '/auth/google_login_url',
    googleAuthLogin: '/auth/google_login'
  },
  integration: {
    getTag: '/integration/getTag',
    getUrl: '/integration/getRedirectUrl',
    getIframe: '/integration/getIframeUrl'
  },
  reports: {
    realTimeAnalysis: {
      getReport: '/realTimeAnalysis/getReport',
      getReportFile: '/realTimeAnalysis/getReportFile',
      addPreset: '/realTimeAnalysis/preset/add',
      listPreset: '/realTimeAnalysis/preset/list',
      removePreset: (id: number | string) => `/realTimeAnalysis/preset/remove/${id}`,
      updatePreset: '/realTimeAnalysis/preset/update',
      alertRule: {
        add: '/realTimeAnalysis/alertRule/add',
        list: '/realTimeAnalysis/alertRule/list',
        get: (id: number | string) => `/realTimeAnalysis/alertRule/get/${id}`,
        test: '/realTimeAnalysis/alertRule/test',
        remove: (id: number | string) => `/realTimeAnalysis/alertRule/remove/${id}`,
        update: '/realTimeAnalysis/alertRule/update'
      }
    },
  },
  postAnalysis: {
    task: {
      list: '/postAnalysis/task/list',
      listAutoRefresh: '/postAnalysis/task/listAutoRefresh',
      create: '/postAnalysis/task/create',
      shortReport: '/postAnalysis/task/shortReport'
    }
  },
  claimReport: {
    task: {
      report: '/claimReport/task/report',
      list: '/claimReport/task/list',
      listAutoRefresh: '/claimReport/task/listAutoRefresh',
      create: '/claimReport/task/create',
      downloadPdf: '/claimReport/task/reportFile',
      downloadCsv: '/claimReport/task/reportLogFile'
    }
  },
  notifications: {
    list: '/notificationChannel/list',
    create: '/notificationChannel/create',
    delete: (id: number) => `/notificationChannel/delete/${ id }`,
    update: '/notificationChannel/update'
  },
  users: {
    list: '/additionalUser/list',
    create: '/additionalUser/create',
    delete: (id: number) => `/additionalUser/delete/${ id }`
  },
  finance: {
    overview: '/finance/overview',
    expenses: '/finance/expenses',
    pay: '/finance/pay',
    paymentFee: '/finance/paymentFee',
    subscriptions: '/finance/subscriptions',
    subscription: '/finance/subscription',
    subscriptionTypes: '/finance/subscriptionTypes',
    buySubscription: '/finance/buySubscription',
    trialActivation: '/finance/trialActivation',
    trialActivationPending: '/finance/trialActivation',
    setAutoRenewSettings: '/finance/setAutoRenewSettings',
    setDefaultCard: '/finance/setDefaultCard',
    deleteCard: '/finance/deleteCard',
    getCards: '/finance/getCards',
    addCard: '/finance/addCard'
  },
  userApi: {
    listTokens: '/userApi/listTokens',
    generateToken: '/userApi/generateToken',
    disableToken: '/userApi/disableToken',
    enableToken: '/userApi/enableToken',
    removeToken: '/userApi/removeToken',
  },
  postbacks: {
    list: '/postback/list',
    create: '/postback/create',
    update: '/postback/update',
    delete: (id: number) => `/postback/delete/${ id }`
  },
  scoringSettings: {
    get: '/realTimeAnalysis/trafficScoreSettings/get',
    update: '/realTimeAnalysis/trafficScoreSettings/update',
    reset: '/realTimeAnalysis/trafficScoreSettings/reset'
  },
  stage: 'https://adex-ssp-stage01.rtty.in',
  production: 'https://app.adex.com'
}

const urlAlias = {
  [ urls.postAnalysis.task.listAutoRefresh ]: urls.postAnalysis.task.list,
  [ urls.claimReport.task.listAutoRefresh ]: urls.claimReport.task.list
}

export function getUrlsAlias(url: string): string {
  if (urlAlias[url]) return urlAlias[url]
  return url
}

function freezeObject(obj: object): void {
  if (typeof obj !== 'object') return
  Object.freeze(obj)
  const keys = Object.keys(obj)
  for (let i = 0; i <= keys.length; i++) {
    const key = keys[i]
    freezeObject(obj[key])
  }
}

freezeObject(urls)
